import { LogoIcon } from '../../icons'
import { useUiLabels } from '../../labels'

export function Footer() {
  const labels = useUiLabels()

  return (
    <div className="ap:w-full ap:pb-xl ap:pt-xl ap:mt-md ap:border-t-stroke-accent ap:border ap:border-transparent ap:flex ap:justify-between">
      <div className="ap:flex ap:flex-col ap:gap-md ap:text-xs *:ap:cursor-pointer">
        <a
          href="//autoplan.no/om-oss"
          target="_blank"
          rel="noopener"
          className="ap:text-content-secondary ap:hover:text-primary ap:hover:font-semibold"
        >
          {labels.footerAbout}
        </a>
        <a href="/home/help" className="ap:text-content-secondary ap:hover:text-primary ap:hover:font-semibold">
          {labels.footerContact}
        </a>
      </div>
      <LogoIcon size={56} />
    </div>
  )
}
